// Native-aware API + WebSocket base URLs.
//
// In a bundled Capacitor app the web assets load from capacitor://localhost
// (iOS) or https://localhost (Android), so a relative '/api' and
// `window.location.host` resolve to the device, NOT the backend. Native
// builds must therefore point at the production host explicitly. Web builds
// keep the relative path so nginx proxies /api to the backend on the same
// origin (and uses the page's own host for the WebSocket).
//
// NOTE: the API is reached via app.game-day.app/api (nginx proxy) — there is
// no separate api.game-day.app host. Override with VITE_NATIVE_HOST at build
// time if pointing a dev build at a staging server.
import { Capacitor } from '@capacitor/core';

export const IS_NATIVE = Capacitor.isNativePlatform();

const NATIVE_HOST = import.meta.env.VITE_NATIVE_HOST || 'app.game-day.app';

export const API_BASE = IS_NATIVE ? `https://${NATIVE_HOST}/api` : '/api';

// Host for building absolute, user-visible URLs (e.g. iCal subscription links,
// share links). Native → the prod host; web → the page's own host.
export const APP_HOST = IS_NATIVE
  ? NATIVE_HOST
  : (typeof window !== 'undefined' && window.location.host ? window.location.host : NATIVE_HOST);

// Full origin (scheme + host) for the same purpose.
export const APP_ORIGIN = IS_NATIVE
  ? `https://${NATIVE_HOST}`
  : (typeof window !== 'undefined' ? window.location.origin : `https://${NATIVE_HOST}`);

export const WS_URL = IS_NATIVE
  ? `wss://${NATIVE_HOST}/ws`
  : `${typeof window !== 'undefined' && window.location.protocol === 'https:' ? 'wss:' : 'ws:'}//${typeof window !== 'undefined' ? window.location.host : ''}/ws`;
